import { ca } from '@cian/analytics';

import { useCallback } from 'react';

import { useCardOfferContext } from 'shared/context/CardContext';
import { AnalyticsProducts } from 'shared/utils/analytics/getAnalyticsProducts';

type Category = 'Listing' | 'Phones' | 'favorite' | 'Auction_block' | 'Message_popup' | 'complain';

type Params = {
  action: string;
  category: Category;
  label?: string | number;
};

type Options = {
  label?: boolean;
  /**
   * @default true
   */
  products?: boolean;
};

type EventData = {
  action: string;
  category: Category;
  label?: string | number;
  name: 'oldevent';
  products?: AnalyticsProducts;
};

type CAForCard = (params: Params, options?: Options) => void;

export function useCAForCard(): CAForCard {
  const { analytics } = useCardOfferContext();

  return useCallback<CAForCard>(
    (params, options = {}) => {
      const { products: addProducts = true, label: addGALabel } = options;

      const eventData: EventData = {
        ...params,
        name: 'oldevent',
      };

      if (addGALabel) {
        eventData.label = analytics.gaLabel;
      }

      if (addProducts) {
        eventData.products = [analytics.product];
      }

      ca('eventSite', eventData);
    },
    [analytics],
  );
}
